import React from "react";

class ScaleHighs extends React.Component {
  render() {
    return (
      <div>
        <section
          className="page-top-banner-it-staffing section-gap-full relative"
          data-stellar-background-ratio="0.5"
          style={{ padding: '80px 0'}}
        >
          <div className="overlay overlay-bg" />
          <div className="container">
            <div className="row section-gap-half">
              <div className="col-lg-12 text-center">
                <h1>Scale Highs</h1>
                {/* <p>At a time when technology job demand far outweighs candidate supply for many critical IT positions,
                    working with a highly capable IT talent solutions company has its advantages.
                </p> */}
              </div>
            </div>
          </div>
        </section>

        <section id="Process" className="section-gap-half">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <ul className="timeline">
                  <li>
                    <div className="timeline-image">
                      <img
                        className="rounded-circle img-fluid"
                        src="../../../assets/images/main/arrow-right.png"
                        alt=""
                      />
                    </div>
                    <div className="timeline-panel">
                      <div className="timeline-heading">
                        <h4>Career Development &amp; Hiring Solutions</h4>
                      </div>
                      <br />
                      <div className="timeline-body">
                        <p className="text-muted">
                          <h4>Member</h4>
                          World class platform to connect with other
                          professionals and get hired. No more filling different
                          company templates to apply jobs. Fill once and it will
                          converted into specific company template.
                        </p>
                        <br />
                        <p className="text-muted">
                          <h4>Business</h4>
                          Single platform to hire talented resources for open
                          positions and contract filling.
                        </p>
                      </div>
                    </div>
                    <div className="section-image right">
                      <img className="" src="../../../assets/images/main/right.png" alt="" />
                    </div>
                  </li>
                  <li className="timeline-inverted">
                    <div className="timeline-image">
                      <img
                        className="rounded-circle img-fluid"
                        src="../../../assets/images/main/arrow-left.png"
                        alt=""
                      />
                    </div>
                    <div className="timeline-panel">
                      <div className="timeline-heading">
                        <h4>Project Outsourcing</h4>
                        {/* <h4 className="subheading">An Agency is Born</h4> */}
                      </div>
                      <br />
                      <div className="timeline-body">
                        <p className="text-muted">
                          <h4>Member</h4>
                          Members can work on international projects as full
                          time or part time associate. Members will be selected
                          on basis of profile, skills, credibity points as well
                          as projects success rate in the past.
                        </p>
                        <br />
                        <p className="text-muted">
                          <h4>Business</h4>
                          Business can post projects and hire international
                          talent pool. Business can access huge database of
                          talent pool based on credibity and success rate in the
                          past.
                        </p>
                      </div>
                    </div>
                    <div className="section-image left">
                      <img className="" src="../../../assets/images/main/left.png" alt="" />
                    </div>
                  </li>
                  <li>
                    <div className="timeline-image">
                      <img
                        className="rounded-circle img-fluid"
                        src="../../../assets/images/main/arrow-right.png"
                        alt=""
                      />
                    </div>
                    <div className="timeline-panel">
                      <div className="timeline-heading">
                        <h4>Career Academy</h4>
                        {/* <h4 className="subheading">Transition to Full Service</h4> */}
                      </div>
                      <br />
                      <div className="timeline-body">
                        <p className="text-muted">
                          <h4>Member</h4>
                          Member can enroll free or paid training programs.
                        </p>
                        <br />
                        <p className="text-muted">
                          <h4>Business</h4>
                          Business or professionals can post training programs.
                        </p>
                      </div>
                    </div>
                    <div className="section-image right">
                      <img className="" src="../../../assets/images/main/right.png" alt="" />
                    </div>
                  </li>
                  <li className="timeline-inverted">
                    <div className="timeline-image">
                      <img
                        className="rounded-circle img-fluid"
                        src="../../../assets/images/main/arrow-left.png"
                        alt=""
                      />
                    </div>
                    <div className="timeline-panel">
                      <div className="timeline-heading">
                        <h4>Credibility</h4>
                        {/* <h4 className="subheading">An Agency is Born</h4> */}
                      </div>
                      <br />
                      <div className="timeline-body">
                        <p className="text-muted">
                          <h4>Members</h4>
                          Members can build credibility on education, employment
                          and skills etc in order to get hired or work on
                          international projects as freelancer.
                        </p>
                        <br />
                        <p className="text-muted">
                          <h4>Business</h4>
                          Business can verify background of members or check the
                          credibility of member to get hired for open positions
                          or projects.
                        </p>
                      </div>
                    </div>
                    <div className="section-image left">
                      <img className="" src="../../../assets/images/main/left.png" alt="" />
                    </div>
                  </li>
                  <li className="timeline-inverted">
                    <div className="timeline-image">
                      <h4>
                        Let's
                        <span>Get Started</span>
                        <div><i className="far fa-thumbs-up thumbsup-ico" /></div>
                      </h4>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
    <section className="cta-section section-gap-half relative">

        <div className="overlay overlay-bg" />

        <div className="container">

            <div className="row section-gap-half">

                <div className="col-lg-12 text-center">

                    <h1>Innovate. Adapt. Disrupt. Grow.</h1>

                    <h4>We help our clients leverage intelligent technologies that transform business models, modernize
                        operations, enhance customer experiences, and fuel growth.</h4>

                    <a className="primary-btn" onClick={() => this.props.router.push('/contactUs')}>Let's Get Started</a>

                </div>

            </div>

        </div>

    </section>
      </div>
    );
  }
}

export default ScaleHighs;



// WEBPACK FOOTER //
// ./screens/Services/ScaleHighs.js